module.exports = __webpack_public_path__ + "static/media/activeLoanBorrowerWhite.8752c94e.svg";